import {
  LabelVariants,
  StringVariants,
} from './inputs.interface'
import { IAction } from './actions.interface'


export interface IValues {
  [name: string]: string 
}

export interface ISetting {
  name: string
  label: string
}

export interface IDependencies {
  [name: string]: {
    name: string
    value: string | null
  }
}

export enum IInputType {
  'string',
  'select',
  'radio',
  'date',
  'bank',
  'car',
  'checkbox'
}

export interface IInput {
  isValidate: boolean
  type: 'string' | 'radio' | 'select'
  name: string
  label: string
  variant?: StringVariants
  percent?: number
  labelVariant?: LabelVariants
  placeholder?: string
  description?: string
  emptyErrorText?: string
  notValidErrorText?: string
  disabled?: boolean
  defaultOption?: number
  options?: any
  defaultValue?: string
  dependencies?: { name: string; value: string }
  dispensable?: boolean
  title?: { text: string; variant?: 'large' }
  subtitle?: string
}

export interface IInputData extends IInput {
  badge: string | null
}

export type IInputsData = IInputData[]

export interface IProgressSettings {
  maxPersent: number
  title: string
  titlePercent: string
  footer: string
  footerPercent: string
}

export interface IStepSetting {
  title: string
  percent?: number
  progress?: IProgressSettings
  actions: string[]
  isOptional: string[]
  pixel: string,
  bankSsl?: boolean
}

export interface IStep {
  stepSetting: IStepSetting
  inputs: IInput[]
}

export type Status = 'none' | 'change' | 'check'
export enum STATUS {
  'None',
  'Current',
  'Change',
  'Check',
}

export interface ITitle {
  title: string
  status: STATUS
  addingPercent: number | null
}

export type IChangeValue = (
  name: string,
  value: string,
  isValudate: boolean
) => void
